import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/github/workspace/node_modules/next/dist/client/app-dir/link.js");
